import { render, staticRenderFns } from "./SideMenu.vue?vue&type=template&id=2169fdee&scoped=true"
import script from "./SideMenu.vue?vue&type=script&lang=ts"
export * from "./SideMenu.vue?vue&type=script&lang=ts"
import style0 from "./SideMenu.scss?vue&type=style&index=0&id=2169fdee&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2169fdee",
  null
  
)

export default component.exports